export function formatDuration(from: string, through?: string | null): string {
  const start = new Date(from).getTime();
  const end = through ? new Date(through).getTime() : Date.now();
  const ms = Math.max(0, end - start);
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  const s = Math.floor((ms % 60_000) / 1_000);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export function formatHoursMinutes(ms: number): string {
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:00`;
}

export function getProjectStatus(project: {
  startedAt?: string | null;
  endedAt?: string | null;
}): "active" | "pending" | "completed" {
  if (project.endedAt && new Date(project.endedAt) < new Date())
    return "completed";
  if (project.startedAt && new Date(project.startedAt) <= new Date())
    return "active";
  return "pending";
}
